import { Action } from "@ngrx/store";
import {
    GET_CHANGE_LOG, SET_CHANGE_LOG, DOWNLOAD_CHANGE_LOG_CSV, DOWNLOAD_CHANGE_LOG_CSV_RESPONSE
} from "./actionTypes";

export class GetChangeLog implements Action {
    readonly type = GET_CHANGE_LOG;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class SetChangeLog implements Action {
    readonly type = SET_CHANGE_LOG;
    readonly payload = []
    constructor(changeLog: Array<any>) {
        this.payload = changeLog;
    }
}

export class DownloadChangeLogCsv implements Action {
    readonly type = DOWNLOAD_CHANGE_LOG_CSV;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DownloadChangeLogCsvResponse implements Action {
    readonly type = DOWNLOAD_CHANGE_LOG_CSV_RESPONSE;
    readonly payload = []
    constructor(report: any) {
        this.payload = report;
    }
}

export type Actions = GetChangeLog | SetChangeLog | DownloadChangeLogCsv | DownloadChangeLogCsvResponse;
